import React from 'react';
import ProjectContent from '../components/ProjectContent';

const AiMessage = () => <ProjectContent projectName='ai Message'/>;

export default AiMessage;